export const shareConstants = [
  {
    labels: [
      "Select Account Number",
      "For others",
      "For Self",
      "Number of Shares (Min 15)",
      "Price per Share",
      "Total Share price",
      "Service fee 5%",
      "Total Price",
      "I agree to share personal details provided during account opening for this share purchase, " +
      "I also agree that the terms and conditions that come together with buying shares.",
      "Buy Shares",
      "Full Name",
      "Mother name",
      "National Id number",
      "Phone number",
      "Continue",
      "Under 18 years",
      "Adult",
      "I am a : ",
      "New Share holder",
      "Existing Share holder",
      "Old file number",
      "Enter Pnr",
      "Search",
        "Are you sure?",
        "Share payment request for",
        "Share Amount",
        "Service charge",
        "Total amount",
        "Click confirm to complete purchase request.",
        "Cancel",
        "Confirm",
    ],
  },
  {
    // Amharic
    labels: [
      "የሂሳብ ቁጥር ምረጥ",
      "ለሌሎች",
      "ለራስህ",
      "የአክሲዮን ብዛት (ቢያንስ 15)",
      "በአክሲዮን ዋጋ",
      "ጠቅላላ ዋጋ",
      "የአገልግሎት ክፍያ 5%",
      "ጠቅላላ ዋጋ",
      "ይህን አክሲዮን ለመግዛት በሂሳብ ቁጥር መክፈት ወቅት የሰጠሁትን የግል መረጃ ለማጋራት እስማማለሁ። እንዲሁም አክሲዮን በመግዛት የሚመጡ ውሎች፤ ግዴታዎች እና ሁኔታዎችን እቀበላለሁ።",
      "አክሲዮን ግዛ",
      "ሙሉ ስም",
      "የእናት ስም",
      "የብሄራዊ መታወቂያ ቁጥር",
      "ስልክ ቁጥር",
      "ቀጥል",
      "ከ18 ዓመት በታች",
      "አዋቂ",
      "እኔ ነኝ:",
      "አዲስ የአክሲዮን ባለቤት",
      "ነባር የአክሲዮን ባለቤት",
      "የድሮ ፋይል ቁጥር",
      "PNR አስገባ",
      "ፈልግ",
      "እርግጠኛ ነህ?",
      "ለአክሲዮን ክፍያ ጥያቄ",
      "የአክሲዮን መጠን",
      "የአገልግሎት ክፍያ",
      "ጠቅላላ መጠን",
      "የግ ጥያቄን ለማጠናቀቅ አረጋግጥ ይጫኑ።",
      "ሰርዝ",
      "አረጋግጥ",
    ],
  },
  {
    // Oromo
    labels: [
      "Lakkoofsa Herrega Filadhu",
      "Kan Biroof",
      "Ofii Keessanii",
      "Lakkoofsha Sheerii (Dhibba 15)",
      "Gatiin Sheerii Tokko",
      "Gatiin Sheerii Waliigalaa",
      "Kaffaltii Tajaajilaa 5%",
      "Gatiin Waliigalaa",
      "Ergaa herrega banuuf odeeffannoo dhuunfaa kenname kan qooduun walii gala, akkasumas, gaheen waliin dhufuun sheeraa bituu nan akeeka.",
      "Sheerii Bituu",
      "Maqaa Guutuu",
      "Maqaa Haadha",
      "Lakkoofsa ID Aangoo",
      "Lakkoofsa Bilbila",
      "Itti Fufuu",
      "Waggaa 18 Gadii",
      "Guddaa",
      "Ani:",
      "Bituu Sheerii Haaraa",
      "Bituu Sheerii Jiraachuu",
      "Lakkoofsa Fayyii Duraa",
      "PNR Galchaa",
      "Barbaadi",
      "Mirkaneeffatta?",
      "Gaafii Kaffaltii Sheerii",
      "Gatiin Sheerii",
      "Kaffaltii Tajaajilaa",
      "Gatiin Waliigalaa",
      "Gaafii bituu xumuruuf mirkaneeffadhu.",
      "Dhiisi",
      "Mirkaneeffadhu",
    ],
  },
  {
    // Tigrigna
    labels: [
      "ቁጽሪ ኣክውንት ምረጽ",
      "ንኻልኦት",
      "ንነብስኻ",
      "ቁጽሪ ናህሳት (ቢያንስ 15)",
      "ዋጋ ናህሳ",
      "ጠቕላላ ዋጋ",
      "ክፍሊ ኣገልግሎት 5%",
      "ጠቕላላ ዋጋ",
      "ነዚ ናህሳ ምግዛዝ ኣብ ኣክውንት ኣብ ዝተኸፈተ እዋን እተዋህበ ውልቃዊ ብዝነት ክካፈል እሰማማዕ እየ፣ እተን ምስኡ ዝመጹ ውዕላት እተን እሰማማዕ እየ።",
      "ናህሳ ግዝ",
      "ልሙድ ስም",
      "ስም ኣደ",
      "ቁጽሪ መንነት",
      "ቁጽሪ ተለፎን",
      "ቀጽል",
      "ትሕቲ 18 ዓመት",
      "ዓቢ",
      "ኣነ እየ:",
      "ሓድሽ ተጠቃሚ ናህሳ",
      "ነባሪ ተጠቃሚ ናህሳ",
      "ቁጽሪ ፋይል ኣረጊት",
      "PNR ኣእትው",
      "ድለይ",
      "ርግጸኛ ዲኻ?",
      "ሕቶ ክፍሊት ናህሳ",
      "መጠን ናህሳ",
      "ክፍሊ ኣገልግሎት",
      "ጠቕላላ መጠን",
      "ሕቶ ግዛት ንምውዳእ ኣረጋግጽ ጠውቕ።",
      "ዕጽፍ",
      "ኣረጋግጽ",
    ],
  },
  {
    // Somali
    labels: [
      "Xisaab Nambarka Dooro",
      "Kuwa Kale",
      "Adiga",
      "Tirada Hantiwadaagaha (Ugu Yar 15)",
      "Qiimaha Hantiwadaag",
      "Wadarta Qiimaha",
      "Lacagta Adeegga 5%",
      "Wadarta Qiimaha",
      "Waxaan ogolaadayaa in la wadaago macluumaadka shaqsiyeed ee la siiyay marka la furayo akoonka, sidoo kale, waxaan ogolaadayaa shuruudaha iyo sharciyada lagu iibsanayo hantiwadaagaha.",
      "Hantiwadaag Iibso",
      "Magaca Oo Dhan",
      "Magaca Hooyo",
      "Lambarka Aqoonsiga",
      "Lambarka Taleefanka",
      "Sii Soco",
      "Ka Yar 18 Sano",
      "Qof Weyn",
      "Anigu waxaan ahay:",
      "Hantiwadaag Cusub",
      "Hantiwadaag Hore",
      "Lambarka Faylka Hore",
      "Geli PNR",
      "Raadi",
      "Ma hubtaa?",
      "Codsi Lacag Bixinta Hantiwadaag",
      "Qadarka Hantiwadaag",
      "Lacagta Adeegga",
      "Wadarta Qadarka",
      "Guji xaqiiji si aad u dhammaystirto codsiga iibsiga.",
      "Jooji",
      "Xaqiiji",
    ],
  },
  {
    // Afar
    labels: [
      "Hisab Numri Sagu",
      "Kuwwa Haysite",
      "Kuwwa Nummaysite",
      "Sheera Numri (Ayyab 15)",
      "Sheera Gaddi Numri",
      "Sheera Gaddi Wada",
      "Agabi Xamal 5%",
      "Gaddi Wada",
      "Hisab baxxiimih tanim faxxiimak sugen num kee kee sheera baxxiimak yanih wada, anu sheera baxxiimak yanih wada.",
      "Sheera Baxxi",
      "Summac Taba",
      "Ina Summac",
      "ID Aangoo Numri",
      "Telfan Numri",
      "Itteh Hee",
      "Num 18 Caddo",
      "Qadaar",
      "Anu:",
      "Sheera Baxxi Macca",
      "Sheera Baxxi Haysita",
      "Fayya Numri Muugta",
      "PNR Galhu",
      "Massagu",
      "Masuginniyo?",
      "Sheera Baxxi Kado",
      "Sheera Gaddi",
      "Agabi Xamal",
      "Gaddi Wada",
      "Baxxi kado xagguurek masuginniyo.",
      "Dhaabu",
      "Masuginno",
    ],
  },
];
